import { render } from "./PartnerLogo.vue?vue&type=template&id=2d1e32bb"
import script from "./PartnerLogo.vue?vue&type=script&lang=js"
export * from "./PartnerLogo.vue?vue&type=script&lang=js"

import "./PartnerLogo.vue?vue&type=style&index=0&id=2d1e32bb&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__